<div class="article top">
    <h3 i18n>Provide an effort estimate - choose one of the cards</h3>
    <span i18n class="article-paragraph">Each team member should estimate the complexity of the task (user
        story) to
        be completed.</span>
    <read-more class="article-paragraph">
        This is done by selecting one of the cards below. The numbers on the cards represent the effort or the
        degree of complexity.
    </read-more>
</div>
